import { patientAction } from 'src/redux/actions/constant';

const {
  GET_RECENT_UPLOADED_HISTORY_RESET,
  GET_RECENT_UPLOADED_HISTORY_SUCCESS,
  GET_RECENT_UPLOADED_HISTORY_FAILURE,
} = patientAction;

const intitialstate: object = {
  isHistorySuccess: false,
  response: null,
};

export const getRecentUploadedReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_RECENT_UPLOADED_HISTORY_SUCCESS: {
      return {
        ...state,
        isHistorySuccess: true,
        response: action.payload,
      };
    }

    case GET_RECENT_UPLOADED_HISTORY_FAILURE:
      return {
        ...state,
        isHistorySuccess: false,
        response: action.payload,
      };

    case GET_RECENT_UPLOADED_HISTORY_RESET:
      return intitialstate;

    default:
      return state;
  }
};
